import React, { Component } from 'react'

import logo from './../../assets/logo-404.png'
import logoVIROMA from './../../assets/logo-viroma.png'

export default class Error404 extends Component {
    render() {
        return (
            <section>
                <div className="box">
                    {window.location.href.indexOf('viromatecnologia.com.br') > 0 ?
                            <img src={logoVIROMA} alt={process.env.REACT_APP_NAME}/>
                        :
                            <img src={logo} alt={process.env.REACT_APP_NAME}/>
                    }
                    <img src={logo} alt={process.env.REACT_APP_NAME}/>
                    <span><strong>404</strong></span>
                    <span>Página não encontrada</span>
                </div>
            </section>

                )
            }
        }
        